"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
function getPrograms(data) {
    return __awaiter(this, void 0, void 0, function () {
        var url, configuration, res, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = process.env.FORM_TASK_API + "/v1/intellitec-form/program/list";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    configuration = {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            authorization: "Bearer " + window.token
                        }
                    };
                    return [4, axios_1.default.post(url, data, configuration)];
                case 2:
                    res = _a.sent();
                    return [2, res.data.payload];
                case 3:
                    error_1 = _a.sent();
                    throw {
                        error: error_1,
                        url: url
                    };
                case 4: return [2];
            }
        });
    });
}
exports.getPrograms = getPrograms;
function getTermBeginningByProgram(data) {
    return __awaiter(this, void 0, void 0, function () {
        var url, configuration, res, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = process.env.FORM_TASK_API + "/v1/intellitec-form/term-beginning/list";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    configuration = {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            authorization: "Bearer " + window.token
                        }
                    };
                    return [4, axios_1.default.post(url, data, configuration)];
                case 2:
                    res = _a.sent();
                    return [2, res.data.payload];
                case 3:
                    error_2 = _a.sent();
                    throw {
                        error: error_2,
                        url: url
                    };
                case 4: return [2];
            }
        });
    });
}
exports.getTermBeginningByProgram = getTermBeginningByProgram;
function daleteTermBeginning(data) {
    return __awaiter(this, void 0, void 0, function () {
        var url, configuration, res, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = process.env.FORM_TASK_API + "/v1/intellitec-form/term-beginning/delete";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    configuration = {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            authorization: "Bearer " + window.token
                        }
                    };
                    return [4, axios_1.default.post(url, data, configuration)];
                case 2:
                    res = _a.sent();
                    return [2, res.data.payload];
                case 3:
                    error_3 = _a.sent();
                    throw {
                        error: error_3,
                        url: url
                    };
                case 4: return [2];
            }
        });
    });
}
exports.daleteTermBeginning = daleteTermBeginning;
function getCostsByTermBeginning(data) {
    return __awaiter(this, void 0, void 0, function () {
        var url, configuration, res, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = process.env.FORM_TASK_API + "/v1/intellitec-form/costs/list";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    configuration = {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            authorization: "Bearer " + window.token
                        }
                    };
                    return [4, axios_1.default.post(url, data, configuration)];
                case 2:
                    res = _a.sent();
                    return [2, res.data.payload];
                case 3:
                    error_4 = _a.sent();
                    throw {
                        error: error_4,
                        url: url
                    };
                case 4: return [2];
            }
        });
    });
}
exports.getCostsByTermBeginning = getCostsByTermBeginning;
function sendRequestFinancialFees(json_data, url) {
    return __awaiter(this, void 0, void 0, function () {
        var urlRequest, configuration, res, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    urlRequest = process.env.FORM_TASK_API + "/v1/intellitec-form" + url;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    configuration = {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            authorization: "Bearer " + window.token
                        }
                    };
                    return [4, axios_1.default.post(urlRequest, json_data, configuration)];
                case 2:
                    res = _a.sent();
                    return [2, res.data.payload];
                case 3:
                    error_5 = _a.sent();
                    throw {
                        error: error_5,
                        url: url
                    };
                case 4: return [2];
            }
        });
    });
}
exports.sendRequestFinancialFees = sendRequestFinancialFees;
//# sourceMappingURL=data:application/json;base64,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